export const getSubscribeLabel = ({
  hasUserSentJoinRequest,
  isPrivate,
}: {
  hasUserSentJoinRequest: boolean;
  isPrivate: boolean;
}) => {
  if (!isPrivate) {
    return 'Subscribe';
  }

  return hasUserSentJoinRequest ? 'Request Sent' : 'Request to Subscribe';
};
